import debounce from "debounce-promise";
import SideSlider from "../sideSlider/sideSlider.vue";
import TrashEventsItem from "./trashEventsItem.vue";
import { TrashEventsService } from "@/services/trashEventsApi";
import { XCircleIcon } from "vue-feather-icons";
import TrashEventsSideSliderFilters from "./trashEventsSideSliderFilters.vue";
import AdApi from "@/services/Api";
import { requestWasCanceled } from "@/services/CancellableRequest";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: userGetters } = createNamespacedHelpers("user"),
	REQUEST_DEBOUNCE_TIME = 300;

export default {
	components: {
		SideSlider,
		TrashEventsItem,
		XCircleIcon,
		TrashEventsSideSliderFilters,
	},

	created() {
		this.$eventBus.$on("loadItemTrashEvents", this.showSlider);
	},

	beforeDestroy() {
		this.$eventBus.$off("loadItemTrashEvents", this.showSlider);
	},

	methods: {
		loadData: debounce(loadData, REQUEST_DEBOUNCE_TIME),
		handleTrashEventUpdate,
		showSlider,
		infiniteHandler,
		resetInfiniteLoader
	},

	computed: {
		getOffset,
		...userGetters([
			"activeOutlet",
		])
	},

	data() {
		return {
			params: null,
			show: false,
			trashItems: [],
			sliderWidth: null,
			filter: {},

			pagination: {
				page: 0,
				limit: 10
			},

			// eslint-disable-next-line max-len
			// https://peachscript.github.io/vue-infinite-loading/guide/use-with-filter-or-tabs.html#use-with-filter-tabs
			infiniteId: Number(new Date()),
		};
	},

	watch: {
		show(val) {
			if (val) {
				this.$nextTick(() => {
					document.body.style.overflow = "hidden";
					this.sliderWidth = this.$refs.sideSlider.clientWidth;
				});
			}
			else {
				// when we hide the trash sidebar, reset the items
				this.trashItems = [];
				document.body.style.overflow = "";
			}
		},
		filter() {
			this.resetInfiniteLoader();
		}
	},

};

function showSlider(params) {
	this.show = true;

	if (params)
		this.params = params;

}

function getOffset() {
	return this.pagination.page * this.pagination.limit;
}

function resetInfiniteLoader() {
	this.pagination.page = 0;
	this.trashItems = [];
	// this will trigger a reset of the infinite loader
	this.infiniteId += 1;
}

/**
 * infiniteLoader is the $state object provided by the infinite loader plugin.
 */
// eslint-disable-next-line complexity
async function loadData(infiniteLoader) {
	let request = null;

	try {
		if (this.$route.path.includes("tracked-items")) {
			const dvDate = this.$moment(this.activeOutlet.outlet_data_validity, "YYYY-MM-DD"),
				trackingEnd = this.params.tracking_end_date
					? this.$moment(this.params.tracking_end_date, "DD.MM.YYYY")
					: undefined,
				untilDate = trackingEnd && trackingEnd < dvDate
					? trackingEnd
					: dvDate;

			request = {
				outlet_id: this.activeOutlet.outlet_id,
				start_date: this.$moment(this.params.tracking_start_date, "DD.MM.YYYY").format("DD/MM/YYYY"),
				end_date: untilDate.format("DD/MM/YYYY"),
				type: "all",
				label_id: this.params?.label_id,
				order_by: this.filter.order,
				incorrect_label_reported: this.filter.filter === "incorrect_label_reported" ? true : undefined,
				order_direction: "desc",
				starred: this.filter.filter === "starred" ? true : undefined,
				noted: this.filter.filter === "noted" ? true : undefined,
				limit: this.pagination.limit,
				offset: this.getOffset
			};
		}
		else {
			request = {
				...AdApi.getQueryParams(false, {
					activeDateOverride: this.filter.activeDate,
					activePeriodOverride: this.filter.activePeriod,
					activeCompareToOverride: `average_${this.filter.activePeriod}`,
				}),
				starred: this.filter.filter === "starred" ? true : undefined,
				noted: this.filter.filter === "noted" ? true : undefined,
				incorrect_label_reported: this.filter.filter === "incorrect_label_reported" ? true : undefined,
				order_by: this.filter.order,
				...this.params,
				limit: this.pagination.limit,
				offset: this.getOffset
			};
		}

		if (this.params && this.params.group_id)
			request.group_id = this.params.group_id;

		const { data } = await TrashEventsService.getTrashEvents(request);

		this.trashItems.push(...data);

		this.pagination.page++;

		// tell infinite loader that we loaded the data
		infiniteLoader.loaded();

		/*
		 * if we received less items than the pagination.limit,
		 * that means there is no data on our backend to fetch anymore.
		 */
		if (data.length < this.pagination.limit) {
			// tell infinite loader that we are done.
			infiniteLoader.complete();
			return;
		}

	}
	catch (error) {
		if (requestWasCanceled(error)) {
			// ignore errors for canceled requests
			return;
		}

		// tell infinite loader that we are done, no need to try fetching more items.
		infiniteLoader.complete();
	}
}

function handleTrashEventUpdate(trashEvent) {
	this.trashItems = this.trashItems.map((_trashEvent) => {
		if (_trashEvent.trashevent_id === trashEvent.trashevent_id)
			return trashEvent;


		return _trashEvent;
	});
}

async function infiniteHandler($state) {
	await this.loadData($state);
}
